import React, { useState } from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
// import HeaderSection from ';

function SimOnlyTutorialVideo() {

  const [loading] = useState(false);

  const videoData = [
    {
      thumbnail:
        "https://mailerv2.telsim.com.au/rtap-videos-thumbnails/activate-sim-only-physical-sim-plan.png",
      url:
        "https://mailerv2.telsim.com.au/RTAP-tutorial-videos/activate-sim-only-physical-sim-plan.mp4",
      title: "How to Activate SIM Only Physical SIM Plan?",
      description:
        "Quick guide to activate a SIM Only physical SIM plan, just follow a few simple steps to get started."
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <HeaderSection /> */}

      <div className="payment-gateway-wrapper" style={{ margin: "10px" }}>
        <label>Activate Telsim Sim Only Plan:</label>
      </div>

      <div className="row" style={{ margin: "20px 0" }}>
        {loading ? (
          <p style={{ textAlign: "center", width: "100%" }}>
            Loading videos...
          </p>
        ) : videoData.length > 0 ? (
          videoData.map((video, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
              <div
                className="videoCards"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  textAlign: "center"
                }}
              >
                <video
                  className="video-card-content"
                  controls
                  controlsList="nodownload"
                  disablePictureInPicture
                  poster={video.thumbnail}
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px"
                  }}
                >
                  <source src={video.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                <div style={{ padding: "10px" }}>
                  <h4 style={{ fontSize: "16px", fontWeight: "bold", margin: "10px 0" }}>
                    {video.title}
                  </h4>

                  <p
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      wordWrap: "break-word",
                      whiteSpace: "normal"
                    }}
                  >
                    {video.description}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", width: "100%" }}>
            No videos available.
          </p>
        )}
      </div>
    </DashboardLayout>
  );
}

export default SimOnlyTutorialVideo;